import { render } from "./ValidationsHeader.vue?vue&type=template&id=305759b0"
import script from "./ValidationsHeader.vue?vue&type=script&lang=js"
export * from "./ValidationsHeader.vue?vue&type=script&lang=js"

import "./ValidationsHeader.vue?vue&type=style&index=0&id=305759b0&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__